import produce from "immer";
import moment from "moment";

import {
    GOOGLE_STORE_PURCHASE_LOG_LIST_REQUEST,
    GOOGLE_STORE_PURCHASE_LOG_LIST,
    SET_TOTAL_COUNT,
    SET_GOOGLE_STORE_PURCHASE_LOG_PAGINATION,
    GOOGLE_STORE_PURCHASE_LOG_PAGE_RESET,
} from "../../constants/log/googleStorePurchaseLogContstants";

const initialState = {
    page: 1,
    pageLength: 10,
    beginDate: moment().utc().subtract(3, 'days').format('YYYY-MM-DDT00:00:00'),
    endDate: moment().utc().format('YYYY-MM-DDT23:59:59'),
    searchCode: '',
    searchString: '',
    totalCount: 0,
}

const googleStorePurchaseLogReducer = (state = initialState, action = {}) => produce(state, draft => {
    switch (action.type) {
        case GOOGLE_STORE_PURCHASE_LOG_LIST_REQUEST:
            break;
        case GOOGLE_STORE_PURCHASE_LOG_LIST:
            draft.list = action.list;
            break;
        case SET_TOTAL_COUNT:
            draft.totalCount = action.totalCount;
            break;
        case SET_GOOGLE_STORE_PURCHASE_LOG_PAGINATION:
            draft.page = action.page;
            draft.totalCount = action.totalCount;
            draft.beginDate = action.beginDate;
            draft.endDate = action.endDate;
            draft.searchCode = action.searchCode;
            draft.searchString = action.searchString;
            break;
        case GOOGLE_STORE_PURCHASE_LOG_PAGE_RESET:
            draft.page = 1;
            draft.beginDate = moment().utc().subtract(3, 'days').format('YYYY-MM-DDT00:00:00');
            draft.endDate = moment().utc().format('YYYY-MM-DDT23:59:59');
            draft.searchCode = '';
            draft.searchString = '';
            break;
        default:
            break;
    }
});

export default googleStorePurchaseLogReducer;